<script lang="ts">
  // only used for researhch purposes, to export csv data of results

  import { logger } from "../utilities/logger";

  logger("Should not call: ResultCsvData");

  //   import { Icons } from "../utilities/icons";
  //   import { Pages } from "../enums";
  //   import type { Result } from "../types";

  //   import { route } from "../stores/route.svelte";
  //   import {
  //     pwaEmailForResults,
  //     pwaNameForResults,
  //   } from "../stores/user-store.svelte";
  //   import { savedResults } from "../stores/saved-results.svelte";
  //   import { user } from "../stores/user-store.svelte";
  //   import IconButton from "../components/IconButton.svelte";

  //   // STATE -------------------------------------------------------

  //   // list of results to display, construct from firestore database
  //   let listItems: Array<string> = [];

  //   // FUNCTIONS -------------------------------------------------------

  //   const makeList = () => {
  //     listItems.push(
  //       "SESSION;ACTION;ID;DATE;STARTTIME;ENDTIME;STEP;ITEM1;ITEM1;ITEM3;ITEM4;ATTEMPT;TARGET;CORRECT;RT",
  //     );
  //     let sortedResults: Result[] = [...savedResults.value];
  //     sortedResults.sort((a, b) => parseFloat(a.session) - parseFloat(b.session));

  //     sortedResults.forEach((sortedResult) => {
  //       if (sortedResult.responseDetails) {
  //         let responseDetails = [...savedResults.value[0].responseDetails];
  //         let index = 0;
  //         responseDetails.forEach((response) => {
  //           index++;
  //           listItems.push($
  //             sortedResult.session.toString() +
  //               ";" +
  //               index.toString() +
  //               ";" +
  //               user.value.name +
  //               ";" +
  //               new Intl.DateTimeFormat("da-DK", { dateStyle: "short" }).format(
  //                 sortedResult.endTime.toDate(),
  //               ) +
  //               ";" +
  //               new Intl.DateTimeFormat("da-DK", { timeStyle: "medium" }).format(
  //                 sortedResult.startTime.toDate(),
  //               ) +
  //               ";" +
  //               new Intl.DateTimeFormat("da-DK", { timeStyle: "medium" }).format(
  //                 sortedResult.endTime.toDate(),
  //               ) +
  //               ";" +
  //               response.step.toString() +
  //               ";" +
  //               sortedResult.items[0] +
  //               ";" +
  //               sortedResult.items[1] +
  //               ";" +
  //               sortedResult.items[2] +
  //               ";" +
  //               sortedResult.items[3] +
  //               ";" +
  //               response.attempt.toString() +
  //               ";" +
  //               response.targetItem +
  //               ";" +
  //               (response.correct ? "1" : "0") +
  //               ";" +
  //               Math.abs(response.responseTime - response.presentTime).toFixed(3),
  //           );
  //         });
  //       }
  //     });
  //   };

  //   // button click ---

  //   const backButtonClicked = () => {
  //     route.current = Pages.ResultList;
  //   };

  //   // INITIALIZE ------------------------------------------------------

  //   makeList();
</script>

<!-- HTML ===================================================== -->
<!-- 
<main>
  <div class="heading">
    <h1>Csv data: {pwaNameForResults.value} - {pwaEmailForResults.value}</h1>
  </div>

  <div class="list-area">
    {#each listItems as item}
      <p>{item}</p>
    {/each}
  </div>

  <div class="bottom-area">
    <span class="button-spacing">
      <IconButton
        onclick={backButtonClicked}
        textMediumScaled={true}
        icon={Icons.ArrowLeft}
      >
        {#snippet message()}Tilbage{/snippet}
      </IconButton>
    </span>
  </div>
</main> -->

<!-- CSS ===================================================== -->
<style>
  /* main {
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    flex-direction: column;
  }
  h1 {
    font-size: 3vmin;
  }
  .heading {
    padding: 1vmin;
  }
  .list-area {
    border: rgb(55, 52, 103) solid;
    background-color: var(--list-background-color);
    margin: var(--std-padding);
    line-height: 1.3em;
    padding: 0 1% 0 1%;
    overflow: scroll;
    flex-grow: 1;
    font-size: 1rem;
    line-height: 1.2;
  }
  .bottom-area {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-right: 1vmin;
    padding-bottom: 1vmin;
    border-top: 2px solid var(--key-hover-border-color);
  }
  .button-spacing {
    padding-top: 1vmin;
    padding-left: 1vmin;
  } */
</style>
